const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const BlessedCondition = function( instigator, owner, battleState, potency, duration ) {
	const condition = new Condition( instigator, owner, battleState, potency );
	condition.handle = 'blessed';
	condition.ConditionClass = BlessedCondition;

	const extant = BattleCalc.getCondition( owner, 'blessed' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = BlessedCondition

BlessedCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return BlessedCondition(instigator, owner, battleState, cState.potency, remainingDuration);
};
